<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    label="Участник"
    no-data-text="Участник не найден"
    :request="request"
    v-on="$listeners"
  >
    <template #item="{ on, item, attrs }">
      <v-list-item :class="attrs.disabled ? 'v-list-item--disabled' : ''" v-on="on">
        <v-list-item-content>
          <v-list-item-title
            class="body-2 font-weight-regular"
            style="white-space: initial;"
            v-text="item.name"
          />
        </v-list-item-content>


        <v-list-item-action v-if="excludedRemovable && attrs.disabled" style="pointer-events: auto !important;">
          <v-tooltip right>
            <template #activator="scope">
              <v-btn
                icon
                color="error"
                small
                v-bind="scope.attrs"
                @click.stop="$emit('action:delete', item)"
                v-on="scope.on"
              >
                <v-icon small>
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
    </template>
  </BAutocomplete>
</template>

<script>
import { openApiMixin } from './mixins'
import { ParticipantsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompleteParticipant',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  props: {
    excludedRemovable: Boolean,
  },
  created() {
    const api = new ParticipantsApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(params, ...args) {
      const { model } = this
      return this.adapter.getAll({ ...params, model }, ...args)
    },
  },
}
</script>
